import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  epapers: [],
};

//internally using immer lib (can create mutable state)
export const epaperSlice = createSlice({
  name: "epaperData",
  initialState,
  reducers: {
    updateAllEPaper: (state, action) => {
      state.epapers = action.payload;
    },
  },
});

// this is for dispatch
export const {  updateAllEPaper } = epaperSlice.actions;

// this is for configureStore
export default epaperSlice.reducer;
